/**
 * エラーコードの定数定義
 */
export const ErrorCodeConstants = {
  // エラーコード一覧(4桁目'W'とする)
  ERROR_CODES: {
    EAPZ000001: 'EAPW000001',
    EAPZ000003: 'EAPW000003',
    EAPZ000004: 'EAPW000004',
    EAPZ000018: 'EAPW000018',
    EAPZ000019: 'EAPW000019',
    EAPZ000020: 'EAPW000020',
    EAPZ000050: 'EAPW000050',
    EAPZ000051: 'EAPW000051',
    EBAZ000015: 'EBAW000015',
    FDXZ000005: 'FDXW000005',
    FIFA000001: '',
    // ここから画面固有
    EAPZ000027: 'EAPW000027',
    EBAA000028: 'EBAW100028',
    EBAZ000023: 'EBAW000023',
    EBAZ000078: 'EBAW000078',
    EBAZ000096: 'EBAW000096',
    EBAZ000097: 'EBAW000097',
    EBAZ000098: 'EBAW000098',
    EBAZ000106: 'EBAW000106',
    EBAZ000143: 'EBAW000143',
    EBAZ000145: 'EBAW000145',
    EBAZ000146: 'EBAW000146',
    EBAZ000147: 'EBAW000147',
    EBAZ000149: 'EBAW000149',
    EBAZ000151: 'EBAW000151',
    EBAZ000155: 'EBAW000155',
    EBAZ000157: 'EBAW000157',
    EBAZ000159: 'EBAW000159',
    EBAZ000160: 'EBAW000160',
    EBAZ000161: 'EBAW000161',
    EBAZ000162: 'EBAW000162',
    EBAZ000163: 'EBAW000163',
    EBAZ000164: 'EBAW000164',
    EBAZ000165: 'EBAW000165',
    EBAZ000189: 'EBAW000189',
    EBAZ000190: 'EBAW000190',
    EBAZ000191: 'EBAW000191',
    EBAZ000192: 'EBAW000192',
    EBAZ000193: 'EBAW000193',
    EBAZ000194: 'EBAW000194',
    EBAZ000195: 'EBAW000195',
    EBAZ000196: 'EBAW000196',
    EBAZ000197: 'EBAW000197',
    EBAZ000198: 'EBAW000198',
    EBAZ000246: 'EBAW000246',
    EBAZ000247: 'EBAW000247',
    EBAZ000248: 'EBAW000248',
    EBAZ000251: 'EBAW000251',
    EBAZ000252: 'EBAW000252',
    EBAZ000253: 'EBAW000253',
    EBAZ000254: 'EBAW000254',
    EBAZ000255: 'EBAW000255',
    EBAZ000256: 'EBAW000256',
    EBAZ000257: 'EBAW000257',
    EBAZ000258: 'EBAW000258',
    EBAZ000259: 'EBAW000259',
    EBAZ000260: 'EBAW000260',
    EBAZ000261: 'EBAW000261',
    EBAZ000262: 'EBAW000262',
    EBAZ000263: 'EBAW000263',
    EBAZ000264: 'EBAW000264',
    EBAZ000265: 'EBAW000265',
    EBAZ000266: 'EBAW000266',
    EBAZ000267: 'EBAW000267',
    EBAZ000268: 'EBAW000268',
    EBAZ000269: 'EBAW000269',
    EBAZ000270: 'EBAW000270',
    EBAZ000271: 'EBAW000271',
    EBAZ000298: 'EBAW000298',
    EBAZ000303: 'EBAW000303',
    EBAZ000304: 'EBAW000304',
    EBAZ000314: 'EBAW000314',
    EBAZ000315: 'EBAW000315',
    EBAZ000316: 'EBAW000316',
    EBAZ000367: 'EBAW000367',
    EBAZ000380: 'EBAW000380',
    EBAZ000384: 'EBAW000384',
    EBAZ000385: 'EBAW000385',
    EBAZ000386: 'EBAW000386',
    EBAZ000394: 'EBAW000394',
    EBAZ000396: 'EBAW000396',
    EBAZ000404: 'EBAW000404',
    EBAZ000406: 'EBAW000406',
    EBAZ000407: 'EBAW000407',
    EBAZ000408: 'EBAW000408',
    EBAZ000409: 'EBAW000409',
    EBAZ000410: 'EBAW000410',
    EBAZ000411: 'EBAW000411',
    EBAZ000413: 'EBAW000413',
    EBAZ000414: 'EBAW000414',
    EBAZ000416: 'EBAW000416',
    EBAZ000417: 'EBAW000417',
    EBAZ000418: 'EBAW000418',
    EBAZ000419: 'EBAW000419',
    EBAZ000421: 'EBAW000421',
    EBAZ000433: 'EBAW000433',
    EBAZ000434: 'EBAW000434',
    EBAZ000500: 'EBAW000500',
    EBAZ000520: 'EBAW000520',
    EBAZ000544: 'EBAW000544',
    EBAZ000584: 'EBAW000584',
    EBAZ000585: 'EBAW000585',
    EBAZ000587: 'EBAW000587',
    EBAZ000589: 'EBAW000589',
    EBAZ000596: 'EBAW000596',
    EBAZ000597: 'EBAW000597',
    EBAZ000615: 'EBAW000615',
    EBAZ000631: 'EBAW000631',
    EBAZ000638: 'EBAW000638',
    EBAZ000662: 'EBAW000662',
    EBAZ000674: 'EBAW000674',
    EBAZ000675: 'EBAW000675',
    EBAZ000676: 'EBAW000676',
    EBAZ000684: 'EBAW000684',
    EBAZ000707: 'EBAW000707',
    EBAZ000708: 'EBAW000708',
    EBAZ000709: 'EBAW000709',
    EBAZ000713: 'EBAW000713',
    EBAZ000722: 'EBAW000722',
    EBAZ000724: 'EBAW000724',
    EBAZ000727: 'EBAW000727',
    EBAZ000735: 'EBAW000735',
    EBAZ000736: 'EBAW000736',
    EBAZ000737: 'EBAW000737',
    EBAZ000738: 'EBAW000738',
    EBAZ000739: 'EBAW000739',
    EBAZ000745: 'EBAW000745',
    EBAZ000746: 'EBAW000746',
    EBAZ000747: 'EBAW000747',
    EBAZ000748: 'EBAW000748',
    EBAZ000749: 'EBAW000749',
    EBAZ000751: 'EBAW000751',
    EBAZ000752: 'EBAW000752',
    EBAZ000754: 'EBAW000754',
    EBAZ000755: 'EBAW000755',
    EBAZ000756: 'EBAW000756',
    EBAZ000767: 'EBAW000767',
    EBAZ000773: 'EBAW000773',
    EBAZ000778: 'EBAW000778',
    EBAZ000820: 'EBAW000820',
    EBAZ000822: 'EBAW000822',
    EBAZ000843: 'EBAW000843',
    EBAZ000846: 'EBAW000846',
    EBAZ000847: 'EBAW000847',
    EBAZ000848: 'EBAW000848',
    EBAZ000700: 'EBAW000700',
    EBAZ000702: 'EBAW000702',
    EBAZ000777: 'EBAW000777',
    ECLZ000001: 'ECLW000001',
    ECLZ000002: 'ECLW000002',
    ECLZ000003: 'ECLW000003',
    FOTO000001: 'FOTW000001',
    WBAZ000029: 'WBAW000029',
    WBAZ000030: 'WBAW000030',
    WBAZ000031: 'WBAW000031',
    WBAZ000032: 'WBAW000032',
    WBAZ000033: 'WBAW000033',
    WBAZ000034: 'WBAW000034',
    WBAZ000035: 'WBAW000035',
    WBAZ000036: 'WBAW000036',
    WBAZ000037: 'WBAW000037',
    WBAZ000038: 'WBAW000038',
    WBAZ000039: 'WBAW000039',
    WBAZ000040: 'WBAW000040',
    WBAZ000043: 'WBAW000043',
    WBAZ000044: 'WBAW000044',
    WBAZ000045: 'WBAW000045',
    WBAZ000048: 'WBAW000048',
    WBAZ000152: 'WBAW000152',
    WBAZ000198: 'WBAW000198',
    WBAZ000213: 'WBAW000213',
    WBAZ000214: 'WBAW000214',
    WBAZ000218: 'WBAW000218',
    WBAZ000219: 'WBAW000219',
    WBAZ000223: 'WBAW000223',
    WBAZ000224: 'WBAW000224',
    WBAZ000225: 'WBAW000225',
    WBAZ000226: 'WBAW000226',
    WBAZ000238: 'WBAW000238',
    WBAZ000239: 'WBAW000239',
    WBAZ000241: 'WBAW000241',
    WBAZ000242: 'WBAW000242',
    WBAZ000253: 'WBAW000253',
    WBAZ000254: 'WBAW000254',
    WBAZ000257: 'WBAW000257',
    WBAZ000355: 'WBAW000355',
    WBAZ000389: 'WBAW000389',
    WBAZ000428: 'WBAW000428',
    WBAZ000556: 'WBAW000556',
    WBAZ000557: 'WBAW000557',
    WBAZ000558: 'WBAW000558',
    WBAZ000562: 'WBAW000562',
    WBAZ000563: 'WBAW000563',
    WBAZ000564: 'WBAW000564',
    WBAZ000573: 'WBAW000573',
    WBAZ000577: 'WBAW000577',
    WBAA100012: 'WBAW100012',
    EBAA000029: 'EBAW100029',
    EBAA000030: 'EBAW100030',
    EBAA000037: 'EBAW100037',
  },
};

/**
 * 共通処理で利用する定数の定義
 */
export const CommonConstants = {
  THREE_LETTER: 'IBX',
  // オフィスコードチェック用定数
  OFFICE_CODE_JP: 'TYOFW08', // 日本統合オフィスコード
  OFFICE_CODE_JP_R: 'TYOFW08AA', // 有償日本オフィス
  OFFICE_CODE_JP_R_APF: '', // 有償日本オフィスAPF
  OFFICE_CODE_JP_A: 'TYOFW08ZZ', // 特典日本オフィス
  // 提携3社ログインモーダルで(ADO,SFJ,SNJ)会員番号チェック用定数
  MEMBER_NUMBER_RULES: {
    type: '' as '' | 'alphaNumberic' | 'numberic',
    length: 0,
  },
  // ログインモーダルのパスワードチェック用定数
  PASSWORD_RULES: {
    minPwLength: 0,
    maxPwLength: 0,
    pwRegex: '.*',
  },
  // ログイン情報連携機能が有効か
  LOGIN_INFO_INTEGRATION_ENABLED: false,
  // 提携社サイトに戻る際のURL切り替え機能が有効か
  RETURN_URL_SWITCH_ENABLED: false,
  LOGO_FILE_PATH: 'assets/images/logo_ibx.svg',
  // 法人ヘッダー用ロゴファイルパス
  LOGO_BIZ_FILE_PATH: 'assets/images/logo_ibx_biz.svg',
  // ログインAPIエラーコードMAP
  LOGIN_API_ERROR_MAP: {} as { [key: string]: string },
  // InlineTelemetry付与対象URL
  INLINETELEMETRY_URL: {
    PAYMENT_RECORD: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/payment-records/,
      METHOD: 'POST',
    },
    CREATE_ORDER: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/create-order/,
      METHOD: 'POST',
    },
    CAPTCHA_AUTHENTICATION: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/captcha-authentication$/,
      METHOD: 'POST',
    },
    CREATE_CART: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/carts\/create-cart/,
      METHOD: 'POST',
    },
    ROUNDTRIP_FPP: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/roundtrip-fpp/,
      METHOD: 'POST',
    },
  } as { [key: string]: { ENDPOINT: RegExp; METHOD: string } },
} as const;

/**
 * APP内で利用する定数の定義
 */
export const AppConstants = {
  // 画像の定数一覧
  IMG: {
    LOGO_S: 'assets/images/logo_ibx_s.svg',
    LOGO_BIZ: 'assets/images/logo_ibx_biz.svg',
    LOGO_S_WIDTH: '56',
    LOGO_S_HEIGHT: '22',
    LOGO_BIZ_WIDTH: '', // IBXは法人無し
    LOGO_BIZ_HEIGHT: '', // IBXは法人無し

    // ツールチップ
    ICON_HELP: 'assets/images/icon_help_ibx_white_navy_20.svg',

    // S01-P010-S01-U: 予約検索画面
    S01_P010_S01_U_XXX: '',

    // S01-P020-S01-U: 予約一覧画面
    S01_P020_S01_U_XXX: '',
    S01_P020_S01_U__ICON__ERROR_TRI_20: `assets/images/icon_error_tri_ibx_red_20.svg`,
    S01_P020_S01_U__ICON__LINK_PRIMARY_20: `assets/images/icon_link_ibx_navy_20.svg`,

    // S01-P030-S01-U: 予約詳細画面
    S01_P030_S01_U_XXX: '',

    // S01-P031-S01-U: 予約詳細(旅程)画面
    S01_P031_S01_U_XXX: '',
    S01_P030_S01_U__LINK: 'assets/images/icon_link_ibx_navy_20.svg',
    S01_P030_S01_U__PLANE_ACTIVE: 'assets/images/icon_plane_line_ibx_navy_32.svg',
    S01_P030_S01_U__AVATOR_ACTIVE: 'assets/images/icon_avator_ibx_navy_32.svg',
    S01_P030_S01_U__CHECKIN_SEAT_ACTIVE: 'assets/images/icon_checkin_seat_ibx_navy_32.svg',
    S01_P030_S01_U__TOOLTIP: 'icon_help_ibx_navy_20.svg',
    S01_P030_S01_U__ANOTHER_WINDOW: 'assets/images/icon_external_ibx_navy_16.svg',
    S01_P030_S01_U__Wifi_AVAILABLE: '',
    S01_P030_S01_U__Wifi_NOT_AVAILABLE: '',
    S01_P030_S01_U__Wifi_POSSIBLY_AVAILABLE: '',

    // S01-P032-S01-U: 予約詳細(搭乗者)画面
    S01_P032_S01_U_XXX: '',

    // S01-P033-S01-U: 予約詳細(サービス)画面
    S01_P033_S01_U_XXX: '',

    // S02-P013-S01-U: ジュニアパイロット申込画面
    S02_P013_S01_U_XXX: '',

    // S03-P010-S01-U: シートマップ画面
    S03_P010_S01_U_XXX: '',
    S03_P010_S01_U__SEATMAP__SEATMAP_AISLE_SHORT: `assets/images/seatmap_aisle_short.svg`,
    S03_P010_S01_U__SEGMENTS__ICON_CHECK_PRIMARY_20: `assets/images/icon_check_ibx_navy_20.svg`,
    S03_P010_S01_U__SEAT_PRODUCTS_MODAL__ICON_EXTERNAL_PRIMARY_16: `assets/images/icon_external_ibx_navy_16.svg`,
    S03_P010_S01_U__LEGENDS_MODAL__BTN_ARROW_CIRCLE_LEFT_40: `assets/images/btn_arrow_circle_left_40.svg`,
    S03_P010_S01_U__LEGENDS_MODAL__BTN_ARROW_CIRCLE_RIGHT_40: `assets/images/btn_arrow_circle_right_40.svg`,
    S03_P010_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_DETAIL: `不使用`,
    S03_P010_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_SEATTYPE: `assets/images/seatmap_float_seattype_ibx.svg`,
    S03_P010_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_LEGEND: `assets/images/seatmap_float_legend_ibx.svg`,
    S03_P010_S01_U__SEAT_EXITDOOR: `assets/images/seat_exitdoor_ibx.svg`,
    S03_P010_S01_U__SEAT_FREE_SEAT_24: `assets/images/seat_ibx_seat_24.svg`,
    S03_P010_S01_U__SEAT_BACK_SEAT_24: `assets/images/seat_back_seat_24.svg`,
    S03_P010_S01_U__SEAT_EMERGENCY_EXIT_SEAT_24: `assets/images/seat_emergency_exit_seat_ibx_24.svg`,
    S03_P010_S01_U__SEAT_UNAVAILABLE_24: `assets/images/seat_unavailable_24.svg`,
    S03_P010_S01_U__SEAT_INFANT_24: `assets/images/seat_infant_24.svg`,
    S03_P010_S01_U__SEAT_SELECTED_24: `assets/images/seat_selected_ibx_24.svg`,
    S03_P010_S01_U__SEAT_BEFORE_CHANGE_FREE_SEAT_24: `assets/images/seat_before_change_free_seat_ibx_24.svg`,
    S03_P010_S01_U__SEAT_UNCHANGEABLE_24: `assets/images/seat_unchangeable_ibx_24.svg`,
    S03_P010_S01_U__SEAT_NO_WINDOW_24: `assets/images/seat_no_window_24.svg`,
    S03_P010_S01_U__SEAT_NO_WINDOW: `assets/images/seat_no_window.svg`,
    S03_P010_S01_U__SEAT_NO_RECLINING_24: `assets/images/seat_no_reclining_ibx_24.svg`,
    S03_P010_S01_U__SEAT_NO_RECLINE: `assets/images/seat_no_recline_ibx.svg`,
    S03_P010_S01_U__SEAT_TABLE_24: `assets/images/seat_table_24.svg`,
    S03_P010_S01_U__SEAT_LAVATORY_24: `assets/images/seat_lavatory_ibx_24.svg`,
    S03_P010_S01_U__SEAT_MULTI_PURPOSE_ROOM_24: `assets/images/seat_multi_purpose_room_24.svg`,
    S03_P010_S01_U__SEAT_AISLE_24: `assets/images/seat_aisle_24.svg`,
    S03_P010_S01_U__SEAT_EMERGENCY_EXIT_24: `assets/images/seat_emergency_exit_24.svg`,
    S03_P010_S01_U__SEAT_WING_24: `assets/images/seat_wing_ibx_24.svg`,
    S03_P010_S01_U__SEAT_GALLEY_24: `assets/images/seat_galley_24.svg`,
    S03_P010_S01_U__SEAT_PARTITION_24: `assets/images/seat_partition_24.svg`,
    S03_P010_S01_U__SEAT_BAR_24: `assets/images/seat_bar_24.svg`,
    S03_P010_S01_U__SEAT_STAIR_24: `assets/images/seat_stair_24.svg`,
    S03_P010_S01_U__SEAT_BASSINET_24: `assets/images/seat_bassinet_24.svg`,

    // S03-P020-S01-U: 座席属性指定画面
    S03_P020_S01_U_XXX: '',

    // S03-P030-S01-U: シートマップ（参照）画面
    S03_P030_S01_U_XXX: '',

    // S04-P010-S01-U: 搭乗者情報入力画面
    S04_P010_S01_U_XXX: '',

    // S05-P011-S01-U: 領収書選択画面
    S05_P011_S01_U_XXX: '',

    // S05-P020-S01-U: 搭乗証明書検索画面
    // TODO: 定数が確定するまでの暫定です
    S05_P020_S01_U_XXX: '',
    S05_P020_S01_U__TOOLTIP: 'assets/images/icon_help_ibx_navy_24.svg',
  },

  // 定数一覧
  CARRIER: {
    TWO_LETTER: 'FW',
    THREE_LETER: 'IBX',
  },
} as const;
